import { RepairOrderQuoteStatusEnum } from 'api-new/generated';
import {
  BlogDecoratedTextDto,
  BlogHeadingDto,
  BlogListItemDto,
  BlogQuoteDto,
  BlogSectionTypes,
  BlogsImageDto,
  BlogTextParagraphDto,
  BlogYoutubeVideoDto,
  BranchType,
  RepairOrderJobLinePayer,
  RepairOrderJobServiceType,
  SortTypeEnum,
  VHCRecordCheckBrakeItemDto,
  VHCRecordCheckItemDto,
  VHCRecordCheckWheelTyreItemDto,
  VHCRecordLogDto
} from 'api/generated';
import { EnumOptions } from 'ts-types';
import { fromEnum } from 'utils/enums';
import { splitPascalCase } from 'utils/strings';

export type SectionForms = {
  [BlogSectionTypes.Heading]: BlogHeadingDto;
  [BlogSectionTypes.TextParagraph]: BlogTextParagraphDto;
  [BlogSectionTypes.YouTubeVideo]: BlogYoutubeVideoDto;
  [BlogSectionTypes.Image]: BlogsImageDto;
  [BlogSectionTypes.TableOfContents]: null;
  [BlogSectionTypes.List]: BlogListItemDto;
  [BlogSectionTypes.DecoratedText]: BlogDecoratedTextDto;
  [BlogSectionTypes.Quote]: BlogQuoteDto;
};

export type GeneralData = Omit<VHCRecordLogDto, 'checkItems' | 'checkBrakeItems' | 'checkWheelTyreItems'>;

export type VhcItemFormType = 'default' | 'brake' | 'wheelTyre';

export type RecordCheckItem = VHCRecordCheckItemDto & { formType: VhcItemFormType; isNew?: boolean };

export type RecordCheckBrakeItem = VHCRecordCheckBrakeItemDto & { formType: VhcItemFormType; isNew?: boolean };

export type RecordCheckWheelTyreItem = VHCRecordCheckWheelTyreItemDto & { formType: VhcItemFormType; isNew?: boolean };

export type VhcItem = RecordCheckItem | RecordCheckBrakeItem | RecordCheckWheelTyreItem;

export interface ConfirmationModalData {
  title?: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => Promise<void>;
}

export type VhcFilter = {
  from?: string;
  to?: string;
  wipNo?: string;
  regNo?: string;
  quoteStatus?: number;
  paginationSkipPagination?: boolean;
  paginationPage?: number;
  paginationMaxCount?: number;
  branch?: BranchType;
  repairOrderQuoteStatus?: RepairOrderQuoteStatusEnum;
  sort?: string | undefined;
  order?: SortTypeEnum | undefined;
};

export type RecordModalData = {
  data: VhcItem;
  isReport?: boolean;
  isComplete?: boolean;
};

export const RepairOrderJobServiceTypeFormat: Record<RepairOrderJobServiceType, string> = {
  [RepairOrderJobServiceType.BODYSHOP]: 'Bodyshop',
  [RepairOrderJobServiceType.INTERNAL]: 'Internal',
  [RepairOrderJobServiceType.MOT]: 'Mot',
  [RepairOrderJobServiceType.RECOVERY]: 'Recovery',
  [RepairOrderJobServiceType.SCHEDULED_MAINTENANCE]: 'Scheduled Maintenance',
  [RepairOrderJobServiceType.SERVICE]: 'Service',
  [RepairOrderJobServiceType.UNSCHEDULED_MAINTENANCE]: 'Unscheduled Maintenance',
  [RepairOrderJobServiceType.WARRANTY]: 'Warranty'
};

export const RepairOrderJobServiceTypeValues = Object.entries(RepairOrderJobServiceTypeFormat).map(
  ([value, label]) => ({
    value: Number(value) as RepairOrderJobServiceType,
    label
  })
);

export const RepairOrderJobLinePayerValues: EnumOptions<typeof RepairOrderJobLinePayer, string>[] = fromEnum(
  RepairOrderJobLinePayer,
  ([label, value]: [keyof typeof RepairOrderJobLinePayer, RepairOrderJobLinePayer]) => ({
    label: splitPascalCase(label),
    value
  })
);
